import { createSlice } from '@reduxjs/toolkit';
import { logout } from './auth/authSlice';

const LOCAL_STORAGE_KEY = 'itemGridPreferences';

const defaultState = {};

function loadState() {
  try {
    const serialized = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!serialized) return defaultState;
    return { ...defaultState, ...JSON.parse(serialized) };
  } catch {
    return defaultState;
  }
}

function saveState(state) {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state));
  } catch {}
}

const itemGridPreferencesSlice = createSlice({
  name: 'itemGridPreferences',
  initialState: loadState(),
  reducers: {
    setVisibleColumns(state, action) {
      const { pageKey, columns } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey].visibleColumns = columns;
      saveState(state);
    },
    setSortOrder(state, action) {
      const { pageKey, sortOrder } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey].sortOrder = sortOrder;
      saveState(state);
    },
    setSortBy(state, action) {
      const { pageKey, sortBy } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey].sortBy = sortBy;
      saveState(state);
    },
    setFilterField(state, action) {
      const { pageKey, field, value } = action.payload;
      state[pageKey] = state[pageKey] || {};
      state[pageKey][field] = value;
      saveState(state);
    },
    resetPreferences(state, action) {
      const { pageKey } = action.payload || {};
      if (pageKey) {
        delete state[pageKey];
      } else {
        Object.keys(state).forEach(key => delete state[key]);
      }
      saveState(state);
    },
  },
  extraReducers: (builder) => {
    // When user logs out (or switches account), clear all saved filters (e.g. location/branch)
    // so the next user does not see the previous account's selections.
    builder.addCase(logout, () => {
      saveState(defaultState);
      return defaultState;
    });
  },
});

export const { setVisibleColumns, setSortOrder, setSortBy, setFilterField, resetPreferences } = itemGridPreferencesSlice.actions;
export default itemGridPreferencesSlice.reducer; 